(function () {
  var tableRoot = document.getElementById("orders-table");

  if (!tableRoot) {
    return;
  }

  var tbody = tableRoot.querySelector("tbody");
  var baseRows = Array.prototype.slice.call(tbody.querySelectorAll("tr"));

  var searchInput = document.getElementById("orders-search");
  var statusSelect = document.getElementById("orders-status");
  var sortSelect = document.getElementById("orders-sort");
  var summary = document.getElementById("orders-summary");
  var jsonButton = document.getElementById("orders-export-json");
  var csvButton = document.getElementById("orders-export-csv");

  function parseNumber(value) {
    return Number(String(value || "").replace(/[^0-9.-]/g, "")) || 0;
  }

  function getInitials(name) {
    var safe = String(name || "User").trim();
    if (!safe) {
      return "U";
    }

    var parts = safe.split(/\s+/).slice(0, 2);
    return parts
      .map(function (part) {
        return part.charAt(0).toUpperCase();
      })
      .join("");
  }

  function createAvatarDataUri(initials) {
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">' +
      "<defs>" +
      '<linearGradient id="g" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0%" stop-color="#2d5f77" />' +
      '<stop offset="100%" stop-color="#163547" />' +
      "</linearGradient>" +
      "</defs>" +
      '<rect width="64" height="64" rx="32" fill="url(#g)" />' +
      '<text x="32" y="40" text-anchor="middle" fill="#ffffff" font-size="24" font-family="Arial, sans-serif" font-weight="700">' +
      initials +
      "</text>" +
      "</svg>";

    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  }

  function hardenAvatars() {
    baseRows.forEach(function (row) {
      var img = row.querySelector("img");

      if (!img || img.dataset.avatarHardened === "1") {
        return;
      }

      img.dataset.avatarHardened = "1";

      var customer = row.getAttribute("data-customer") || "Customer";
      var initials = getInitials(customer);
      var fallbackSrc = createAvatarDataUri(initials);

      function useFallback() {
        if (img.dataset.avatarFallbackApplied === "1") {
          return;
        }

        img.dataset.avatarFallbackApplied = "1";
        img.classList.add("avatar--fallback");
        img.src = fallbackSrc;
        img.alt = customer + " avatar fallback";
      }

      img.addEventListener("error", useFallback);

      if (img.complete && img.naturalWidth === 0) {
        useFallback();
      }
    });
  }

  function getVisibleRows() {
    var query = (searchInput.value || "").trim().toLowerCase();
    var status = statusSelect.value;

    return baseRows.filter(function (row) {
      var rowText = row.textContent.toLowerCase();
      var rowStatus = row.getAttribute("data-status") || "";

      var matchesText = query === "" || rowText.indexOf(query) > -1;
      var matchesStatus = status === "all" || rowStatus === status;

      return matchesText && matchesStatus;
    });
  }

  function sortRows(rows) {
    var mode = sortSelect.value;
    var copy = rows.slice();

    if (mode === "default") {
      return copy;
    }

    copy.sort(function (a, b) {
      if (mode === "id-asc") {
        return parseNumber(a.getAttribute("data-id")) - parseNumber(b.getAttribute("data-id"));
      }
      if (mode === "id-desc") {
        return parseNumber(b.getAttribute("data-id")) - parseNumber(a.getAttribute("data-id"));
      }
      if (mode === "date-newest") {
        return new Date(b.getAttribute("data-date")) - new Date(a.getAttribute("data-date"));
      }
      if (mode === "date-oldest") {
        return new Date(a.getAttribute("data-date")) - new Date(b.getAttribute("data-date"));
      }
      if (mode === "amount-desc") {
        return parseNumber(b.getAttribute("data-amount")) - parseNumber(a.getAttribute("data-amount"));
      }
      if (mode === "amount-asc") {
        return parseNumber(a.getAttribute("data-amount")) - parseNumber(b.getAttribute("data-amount"));
      }
      if (mode === "customer-desc") {
        return (b.getAttribute("data-customer") || "").localeCompare(a.getAttribute("data-customer") || "");
      }
      return (a.getAttribute("data-customer") || "").localeCompare(b.getAttribute("data-customer") || "");
    });

    return copy;
  }

  function render() {
    var filtered = getVisibleRows();
    var sorted = sortRows(filtered);

    tbody.innerHTML = "";
    sorted.forEach(function (row, index) {
      row.style.backgroundColor = index % 2 === 0 ? "transparent" : "rgba(255,255,255,0.04)";
      tbody.appendChild(row);
    });

    summary.textContent = sorted.length + " of " + baseRows.length + " rows visible.";
  }

  function rowsToRecords(rows) {
    return rows.map(function (row) {
      return {
        id: Number(row.getAttribute("data-id")),
        customer: row.getAttribute("data-customer") || "",
        location: row.getAttribute("data-location") || "",
        order_date: row.getAttribute("data-date") || "",
        status: row.getAttribute("data-status") || "",
        amount: parseNumber(row.getAttribute("data-amount")),
      };
    });
  }

  function downloadText(filename, mimeType, text) {
    var a = document.createElement("a");
    a.download = filename;
    a.href = "data:" + mimeType + ";charset=utf-8," + encodeURIComponent(text);
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  function exportVisibleJson() {
    var rows = Array.prototype.slice.call(tbody.querySelectorAll("tr"));
    var records = rowsToRecords(rows);
    downloadText("customer-orders.json", "application/json", JSON.stringify(records, null, 2));
  }

  function csvEscape(value) {
    var text = String(value == null ? "" : value);
    if (/[",\n]/.test(text)) {
      return '"' + text.replace(/"/g, '""') + '"';
    }
    return text;
  }

  function exportVisibleCsv() {
    var rows = Array.prototype.slice.call(tbody.querySelectorAll("tr"));
    var records = rowsToRecords(rows);
    var header = ["id", "customer", "location", "order_date", "status", "amount"];
    var lines = [header.join(",")];

    records.forEach(function (record) {
      lines.push(
        [
          record.id,
          csvEscape(record.customer),
          csvEscape(record.location),
          csvEscape(record.order_date),
          csvEscape(record.status),
          record.amount.toFixed(2),
        ].join(",")
      );
    });

    downloadText("customer-orders.csv", "text/csv", lines.join("\n"));
  }

  searchInput.addEventListener("input", render);
  statusSelect.addEventListener("change", render);
  sortSelect.addEventListener("change", render);
  jsonButton.addEventListener("click", exportVisibleJson);
  csvButton.addEventListener("click", exportVisibleCsv);

  hardenAvatars();
  render();
})();
